import { render, staticRenderFns } from "./Importar.vue?vue&type=template&id=4555617c&"
import script from "./Importar.vue?vue&type=script&lang=js&"
export * from "./Importar.vue?vue&type=script&lang=js&"
import style0 from "./Importar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports